import { css } from '@emotion/react';
import styled from '@emotion/styled';
import {
    ClearButton,
    CloseButton,
    FormField as ClaimFormField,
    FormFieldFullWidth as ClaimFormFieldFullWidth,
    FormGrid,
    Label,
    PopoverBody,
    PopoverContent,
    PopoverFooter,
    PopoverHeader,
    PopoverTitle,
    SearchBarContainer,
    SearchIcon,
    SearchInputWrapper as ClaimSearchInputWrapper,
    SubmitButton as ClaimSubmitButton,
} from '../advanced-search/advanced-claim-search-bar.styles';
import { Variables } from '../base/variables/variables';

export {
    ClearButton,
    CloseButton,
    FormGrid,
    Label,
    PopoverFooter,
    PopoverHeader,
    PopoverTitle,
    SearchBarContainer,
    SearchIcon,
};

export const SubmitButton = styled(ClaimSubmitButton)`
    display: inline-flex;
    align-items: center;
    justify-content: center;
`;


export const SearchInputWrapper = styled(ClaimSearchInputWrapper)`
    input {
        background-color: ${Variables.Swatches.Gray2};

        &:hover {
            background-color: ${Variables.Swatches.Gray2};
        }
    }
`;

/**
 * Claim-search FormField sets `input { height: 32px }`, which also hits the
 * hidden <input> inside react-select and inflates the control (~57px).
 * Keep BaseInput and single-selects at 32px; multi-selects must grow with chips.
 * react-select puts `--is-multi` on the root (`.select--is-multi`), not the control.
 */
const searchControlHeight = css`
    input:not([class*='select']) {
        height: 32px;
        font-size: 14px;
        border-radius: 4px;
    }

    .select__control {
        box-sizing: border-box;
        min-height: 32px;
        height: auto;
        align-items: center;
    }

    .select--is-multi .select__control,
    .select__control--is-multi {
        height: auto;
        min-height: 32px;
        align-items: flex-start;
    }

    .select__value-container {
        margin: 0;
        padding: 0 8px;
        overflow: hidden;
    }

    .select--is-multi .select__value-container,
    .select__value-container--is-multi {
        flex-wrap: wrap;
        overflow: visible;
        height: auto;
        align-content: center;
        padding-top: 2px;
        padding-bottom: 2px;
    }

    .select__indicators {
        height: 100%;
        align-self: stretch;
    }

    .select--is-multi .select__indicators,
    .select__control--is-multi .select__indicators {
        height: auto;
        align-self: flex-start;
        padding-top: 4px;
    }

    .select__dropdown-indicator {
        padding: 0 4px;
    }

    .select__input-container,
    .select__input,
    .select__control input {
        margin: 0 !important;
        padding: 0 !important;
        height: auto !important;
        min-height: 0 !important;
        font-size: 14px;
    }

    .select__single-value {
        margin: 0;
    }
`;

export const FormField = styled(ClaimFormField)`
    ${searchControlHeight}
`;

export const FormFieldFullWidth = styled(ClaimFormFieldFullWidth)`
    ${searchControlHeight}
`;

export const TaskSearchBarContainer = styled(SearchBarContainer)`
    flex: 1 1 auto;
    min-width: 0;
`;

export const TaskSearchPopoverContent = styled(PopoverContent)`
    width: 600px;
    max-height: calc(100vh - 80px);
    overflow: hidden;
`;

export const TaskSearchPopoverBody = styled(PopoverBody)`
    overflow-y: auto;
    max-height: calc(100vh - 220px);
    padding-right: 4px;
    ${searchControlHeight}
`;

export const FooterActions = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const SplitFooter = styled(PopoverFooter)`
    justify-content: flex-end;
`;

export const Hint = styled.span`
    font-size: 12px;
    color: ${Variables.Swatches.Gray7};
    line-height: 1.3;
`;

export const CreatedFilterWrap = styled.div`
    width: 100%;
    ${searchControlHeight}
`;
